import React from "react";
import { Check, X } from "lucide-react";

const fmt = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" })
    : null;

export const ClaimTimeline = ({ claim }) => {
  const rejected = claim.status === "rejected";
  const gifted = claim.status === "gifted";
  const approved = claim.status === "approved";
  const inReview = claim.status === "in_review";
  const finished = rejected || gifted || approved;

  const steps = [
    { label: "Submitted", date: fmt(claim.created_at), state: "done" },
    {
      label: "In Review",
      date: fmt(claim.review_started_at),
      state: finished ? "done" : inReview ? "current" : "todo",
    },
    rejected
      ? { label: "Rejected", date: fmt(claim.processed_at), state: "rejected" }
      : gifted
      ? { label: "Pack Gifted", date: fmt(claim.gifted_pack?.gifted_at || claim.processed_at), state: "done-final" }
      : { label: "Approved", date: fmt(claim.processed_at), state: approved ? "done-final" : "todo" },
  ];

  const dot = (s) => {
    if (s.state === "rejected")
      return (
        <span className="w-5 h-5 rounded-full bg-red-500/25 border border-red-500 flex items-center justify-center">
          <X size={11} className="text-red-400" />
        </span>
      );
    if (s.state === "done" || s.state === "done-final")
      return (
        <span className={`w-5 h-5 rounded-full flex items-center justify-center border ${s.state === "done-final" ? "bg-emerald-500/25 border-emerald-400" : "bg-green-500/20 border-green-500/60"}`}>
          <Check size={11} className={s.state === "done-final" ? "text-emerald-300" : "text-green-400"} />
        </span>
      );
    if (s.state === "current")
      return (
        <span className="w-5 h-5 rounded-full bg-blue-500/25 border border-blue-400 flex items-center justify-center">
          <span className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" />
        </span>
      );
    return <span className="w-5 h-5 rounded-full bg-white/[0.04] border border-white/15" />;
  };

  const lineClass = (i) => {
    const next = steps[i + 1];
    if (next.state === "rejected") return "bg-red-500/50";
    if (next.state === "done" || next.state === "done-final") return "bg-green-500/50";
    if (next.state === "current") return "bg-blue-500/50";
    return "bg-white/10";
  };

  return (
    <div className="flex items-start mt-3 mb-1" data-testid={`claim-timeline-${claim.serial_number}`}>
      {steps.map((s, i) => (
        <React.Fragment key={s.label}>
          <div className="flex flex-col items-center gap-1 min-w-[64px]">
            {dot(s)}
            <span
              className={`text-[10px] font-bold leading-tight text-center ${
                s.state === "rejected" ? "text-red-400" :
                s.state === "done-final" ? "text-emerald-300" :
                s.state === "done" ? "text-green-400" :
                s.state === "current" ? "text-blue-300" : "text-gray-600"
              }`}
            >
              {s.label}
            </span>
            {s.date && <span className="text-[9px] text-gray-600">{s.date}</span>}
          </div>
          {i < steps.length - 1 && (
            <div className={`flex-1 h-[2px] mt-[9px] rounded ${lineClass(i)}`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ClaimTimeline;
